import { Flex } from "src/components/Flex.tsx";
import { css } from "@emotion/react";
import type { GridRenderCellParams } from "@mui/x-data-grid-pro";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { TooltipV2 } from "src/components/TooltipV2/TooltipV2.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";

export const ProductTypeCell = ({ row }: GridRenderCellParams) => {
  const { t } = useTranslation(TranslationNamespaceEnum.TransferPanel);
  const iconMap: Record<string, string> = {
    single: "icon-20-single",
    set: "icon-20-variant-set",
    multiple: "icon-20-variant-set",
    complex: "icon-20-variant-set",
    variant: "icon-20-singl_variant",
  };

  const titles: Record<string, string> = {
    single: t("variant.productTypes.single"),
    set: t("variant.productTypes.parent"),
    multiple: t("variant.productTypes.parent"),
    complex: t("variant.productTypes.parent"),
    variant: t("variant.productTypes.child"),
  };

  return (
    <Flex
      style={{
        height: "100%",
      }}
      alignItems={"center"}
    >
      <TooltipV2 content={titles[row.item_type]}>
        <span css={iconStyles} className={iconMap[row.item_type]} />
      </TooltipV2>
    </Flex>
  );
};

const iconStyles = (theme: ExactTheme) =>
  css({
    fontSize: 20,
    color: theme.colorsV2.blue[500],
  });
